import React from "react";
import { BRAND, waLink } from "@/config/site.config";

// WhatsApp brand icon (SVG, no external dep)
const WhatsAppIcon = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
    <path d="M20.52 3.48A11.86 11.86 0 0 0 12 0C5.37 0 0 5.37 0 12c0 2.12.55 4.18 1.6 6.01L0 24l6.18-1.62A11.94 11.94 0 0 0 12 24c6.63 0 12-5.37 12-12 0-3.2-1.25-6.21-3.48-8.52ZM12 21.82a9.83 9.83 0 0 1-5.01-1.37l-.36-.21-3.67.96.98-3.58-.23-.37A9.82 9.82 0 1 1 12 21.82Zm5.43-7.34c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.27-.47-2.42-1.5-.9-.8-1.5-1.78-1.67-2.08-.18-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.8.37-.27.3-1.05 1.03-1.05 2.5 0 1.47 1.07 2.9 1.22 3.1.15.2 2.1 3.21 5.08 4.5.71.3 1.27.48 1.7.62.71.22 1.36.19 1.87.12.57-.08 1.77-.72 2.02-1.41.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35Z"/>
  </svg>
);

export default function FloatingActions() {
  return (
    <a
      href={waLink(BRAND.whatsappMessage)}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 group"
      data-testid="floating-whatsapp"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-emerald-500/30 blur-xl group-hover:bg-emerald-500/55 transition-all animate-pulse" />
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600 text-white shadow-[0_10px_30px_-10px_rgba(16,185,129,0.6)] transition-transform group-hover:scale-110">
        <WhatsAppIcon className="h-7 w-7" />
      </span>
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 hidden group-hover:inline-flex items-center whitespace-nowrap rounded-full bg-black/85 backdrop-blur border border-white/10 px-3 py-1.5 text-xs text-white">
        Chat on WhatsApp
      </span>
    </a>
  );
}
